import { messageTypes } from './messages.types'

export const setNewMessage = ({ message, teamId, unseen, replyId, noBadgeCount }) => ({
  type: messageTypes.SET_NEW_MESSAGE,
  payload: {
    message,
    teamId,
    unseen,
    replyId,
    noBadgeCount,
  },
})

export const setDepartments = (departments) => ({
  type: messageTypes.SET_DEPARTMENTS,
  payload: departments,
})

export const setActiveDepartment = (department) => ({
  type: messageTypes.SET_ACTIVE_DEPARTMENT,
  payload: department,
})

export const setAcceptedChat = ({ status, agentInfo, teamId, meta }) => ({
  type: messageTypes.SET_ACCEPTED_CHAT,
  payload: { status, agentInfo, teamId, meta },
})

export const setMessageStatus = ({ status, message_id, team_id, progress }) => ({
  type: messageTypes.SET_MESSAGE_STATUS,
  payload: { status, message_id, team_id, progress },
})

export const setFormMessage = (message) => ({
  type: messageTypes.SET_FORM_MESSAGE,
  payload: { message },
})

export const sendMessage = ({ message, teamId }) => ({
  type: messageTypes.SEND_MESSAGE,
  payload: { message, teamId },
})

export const setUserInput = (input, teamId) => ({
  type: messageTypes.SET_USER_INPUT,
  payload: { input, teamId },
})

export const sendFileMessage = (file) => ({
  type: messageTypes.SEND_FILE_MESSAGE,
  payload: file,
})

export const uploadFile = ({ file, teamId, replyId }) => ({
  type: messageTypes.UPLOAD_FILE,
  payload: { file, teamId, replyId },
})

export const setUploadProgressData = ({ percentage, fileType }) => ({
  type: messageTypes.SET_UPLOAD_PROGRESS_DATA,
  payload: {
    percentage,
    fileType,
  },
})

/**
 * Sets data being confirmed for upload
 *
 * @param {{
 *   teamId: string;
 *   replyId: string | undefined;
 *   file: Object;
 *   fileData: string;
 *   fileType: string | number;
 *   type: string;
 *   size: string;
 *   name: string;
 * }} uploadedFileData
 */
export const setConfirmUploadedData = (uploadedFileData) => ({
  type: messageTypes.SET_CONFIRM_UPLOADED_DATA,
  payload: uploadedFileData,
})

export const setUploadError = (errMsg) => ({
  type: messageTypes.SET_UPLOAD_ERROR,
  payload: { errMsg },
})

export const setRemoveMessageByTmpId = ({ tmpId, teamId }) => ({
  type: messageTypes.SET_REMOVE_MSG_BY_TMP_ID,
  payload: { tmpId, teamId },
})

export const setUserDidConfirmTheUploadedData = (confirmUploadedData) => ({
  type: messageTypes.SET_USER_DID_CONFIRM_THE_UPLOADED_DATA,
  payload: confirmUploadedData,
})

export const setVoiceRecording = (isRecording) => ({
  type: messageTypes.SET_VOICE_RECORDING,
  payload: isRecording,
})

export const sendFormMessage = (formFields, teamId) => ({
  type: messageTypes.SEND_FOMR_MESSAGE,
  payload: { formFields, teamId },
})

export const setUserFormStatus = (response) => ({
  type: messageTypes.SET_USER_FORM_STATUS,
  payload: response,
})

export const sendNewTypedWord = (message) => ({
  type: messageTypes.TYPE_NEW_WORD,
  payload: message,
})

export const setFetchMoreMessages = (enable) => ({
  type: messageTypes.SET_FETCH_MORE_MESSAGES,
  payload: enable,
})

export const fetchMoreMessagesStart = (page, conversationId, teamId) => ({
  type: messageTypes.FETCH_MORE_MESSAGES_START,
  payload: { page, conversationId, teamId },
})

export const setOldMessages = ({ messages, teamId }) => ({
  type: messageTypes.SET_OLD_MESSAGES,
  payload: { messages, teamId },
})

export const setDisableInput = ({ status, description }) => ({
  type: messageTypes.SET_DISABLE_INPUT,
  payload: { status, description },
})

export const setRecordingAudio = (audio) => ({
  type: messageTypes.SET_RECORDING_AUDIO,
  payload: audio,
})

/**
 * Submits users feedback about conversation
 *
 * @param {Object} data - feedback data
 */
export const submitFeedback = ({ rate, comment, agentId, conversationId, teamId, setLoadingSubmit }) => ({
  type: messageTypes.SUBMIT_FEEDBACK,
  payload: { rate, comment, agentId, conversationId, teamId, setLoadingSubmit },
})

export const setFeedbackboxValues = ({ teamId, conversationId, ...values }) => ({
  type: messageTypes.SET_FEEDBACK_BOX_VALUES,
  payload: { teamId, conversationId, ...values },
})

export const getAcceptedChatInfo = () => ({
  type: messageTypes.GET_ACCEPTED_CHAT,
})

export const setOffilneMessage = (payload) => ({
  type: messageTypes.SET_OFFLINE_MESSAGE,
  payload: payload,
})

export const updateAcceptedChatAvatar = (avatar) => ({
  type: messageTypes.UPDATE_ACCEPTED_CHAT_AVATAR,
  payload: avatar,
})

export const setConnectionError = (error) => ({
  type: messageTypes.SET_CONNECTION_ERROR,
  payload: error,
})

export const setCurrentUser = (user) => ({
  type: messageTypes.SET_CURRENT_USER,
  payload: user,
})

export const setAudioStream = (stream) => ({
  type: messageTypes.SET_AUDIO_STREAM,
  payload: stream,
})

export const getUserFromApi = (isGetUserFromApi) => ({
  type: messageTypes.GET_USER_FROM_API,
  payload: isGetUserFromApi,
})

export const setSocketConnectionError = ({ status, description }) => ({
  type: messageTypes.SET_SOCKET_CONNECTION_ERROR,
  payload: { status, description },
})

export const setDefaultOnlineAgent = (agent) => ({
  type: messageTypes.SET_DEFAULT_ONLINE_AGENT,
  payload: agent,
})

export const removeAcceptedChat = (teamId) => ({
  type: messageTypes.REMOVE_ACCEPTED_CHAT,
  payload: teamId,
})

// teamId for where form is completed from and form message will be removed from other teams chats.
export const removeFormMessage = (teamId, formId) => ({
  type: messageTypes.REMOVE_FORM_MESSAGE,
  payload: { teamId, formId },
})

// For setting message in state when replying.
export const setReplyingMessage = (message) => ({
  type: messageTypes.SET_REPLYING_MESSAGE,
  payload: message,
})

// For editing message when userEditedMessage triggered.
export const setEditedMessage = ({ message, messageId }) => ({
  type: messageTypes.SET_EDITED_MESSAGE,
  payload: { message, messageId },
})

export const removeConversationNotSeenStart = ({ conversationId, checkIsInChat }) => ({
  type: messageTypes.REMOVE_CONVERSATION_NOT_SEEN_START,
  payload: { conversationId, checkIsInChat },
})

export const setMsgStatus = ({ status, messageId }) => ({
  type: messageTypes.SET_MSG_STATUS,
  payload: { status, messageId },
})

export const setMsgId = ({ prevId, newId }) => ({
  type: messageTypes.SET_MSG_STATUS,
  payload: { prevId, newId },
})

export const setSeenStatusForAllMessages = ({ conversationId, teamId }) => ({
  type: messageTypes.SET_SEEN_STATUS_FOR_ALL_MESSAGES,
  payload: { conversationId, teamId },
})

export const setMessageId = ({ prevId, newId, teamId }) => ({
  type: messageTypes.SET_MESSAGE_ID,
  payload: { prevId, newId, teamId },
})

export const setSelectedQuestion = (question) => ({
  type: messageTypes.SET_SELECTED_QUESTION,
  payload: question,
})

export const recordRoadmapCheckpoint = (data) => ({
  type: messageTypes.RECORD_ROADMAP_CHECKPOINT,
  payload: data,
})

export const sendDynamicFormMessage = ({ data, setUserFormStatus }) => ({
  type: messageTypes.SEND_DYNAMIC_FORM_MESSAGE,
  payload: { data, setUserFormStatus },
})

export const dispatchFormAndMessage = (data) => ({
  type: messageTypes.DISPATCH_FORM_AND_MESSAGE,
  payload: data,
})

export const changeBotMessageToText = (tmpId, teamId, content) => ({
  type: messageTypes.CHANGE_BOT_MSG_TO_TEXT,
  payload: { tmpId, teamId, content },
})

export const setSubmitedFormStatus = (data) => ({
  type: messageTypes.SET_FORM_STATUS,
  payload: data,
})

export const setHideChatInputForTeams = (teamIdsArray) => ({
  type: messageTypes.HIDE_CHAT_INPUT_FOR_TEAM,
  payload: teamIdsArray,
})

export const setShowGreetingInput = (status) => ({
  type: messageTypes.SET_SHOW_GREETING_INPUT,
  payload: status,
})

/**
 * sets number of unseen received messages
 *
 * @param {Object.<string, number>} profileCounts - An object where the keys are teamIds and the values are counts
 *
 * @example
 * // example of param object
 * const notSeenReceivedMsgsByTeam = {
 *  "656d64fd5c6a9f76463675bc": 2
 * }
 */
export const setNotSeenReceivedMsgs = (notSeenReceivedMsgsByTeam) => ({
  type: messageTypes.SET_NOT_SEEN_RECEIVED_MSGS,
  payload: notSeenReceivedMsgsByTeam,
})

export const incrementNotSeenReceivedMsgs = (teamId) => ({
  type: messageTypes.INCREMENT_NOT_SEEN_RECEIVED_MSGS,
  payload: teamId,
})

export const restartFlowOperation = () => ({
  type: messageTypes.RESTART_FLOW_OPERATION,
})

export const talkWithOperatorInsteadOfBot = (data) => ({
  type: messageTypes.TALK_WITH_OPERATOR_INSTEAD_OF_BOT,
  payload: data,
})

// removes a message
export const removeMessage = ({ teamId, createdAt, msgType }) => ({
  type: messageTypes.REMOVE_MESSAGE,
  payload: { teamId, createdAt, msgType },
})

export const performAutoMsgOpenWidgetAction = ({ launcherContentState, teamId }) => ({
  type: messageTypes.OPEN_WIDGET_AUTO_MSG_ACTION,
  payload: { launcherContentState, teamId },
})

export const setSentCloseButton = ({ data, teamId }) => ({
  type: messageTypes.SET_SENT_CLOSE_BUTTON,
  payload: { data, teamId },
})

export const sendSentCloseButtonAction = ({ value }) => ({
  type: messageTypes.SEND_SENT_CLOSE_BUTTON_ACTION,
  payload: { value },
})
